import emailValidator from 'email-validator'
import CardValidator from 'card-validator'

// Validation error factory method
export function validationError(source, message, payload = undefined) {
  const error = new Error(message)
  error.source = source
  error.message = message
  if (payload) error.payload = payload
  return error
}

export const states = [
  {
    name: 'Alabama',
    value: 'AL',
  },
  {
    name: 'Alaska',
    value: 'AK',
  },
  {
    name: 'Arizona',
    value: 'AZ',
  },
  {
    name: 'Arkansas',
    value: 'AR',
  },
  {
    name: 'California',
    value: 'CA',
  },
  {
    name: 'Colorado',
    value: 'CO',
  },
  {
    name: 'Connecticut',
    value: 'CT',
  },
  {
    name: 'Delaware',
    value: 'DE',
  },
  {
    name: 'Florida',
    value: 'FL',
  },
  {
    name: 'Georgia',
    value: 'GA',
  },
  {
    name: 'Hawaii',
    value: 'HI',
  },
  {
    name: 'Idaho',
    value: 'ID',
  },
  {
    name: 'Illinois',
    value: 'IL',
  },
  {
    name: 'Indiana',
    value: 'IN',
  },
  {
    name: 'Iowa',
    value: 'IA',
  },
  {
    name: 'Kansas',
    value: 'KS',
  },
  {
    name: 'Kentucky',
    value: 'KY',
  },
  {
    name: 'Louisiana',
    value: 'LA',
  },
  {
    name: 'Maine',
    value: 'ME',
  },
  {
    name: 'Maryland',
    value: 'MD',
  },
  {
    name: 'Massachusetts',
    value: 'MA',
  },
  {
    name: 'Michigan',
    value: 'MI',
  },
  {
    name: 'Minnesota',
    value: 'MN',
  },
  {
    name: 'Mississippi',
    value: 'MS',
  },
  {
    name: 'Missouri',
    value: 'MO',
  },
  {
    name: 'Montana',
    value: 'MT',
  },
  {
    name: 'Nebraska',
    value: 'NE',
  },
  {
    name: 'Nevada',
    value: 'NV',
  },
  {
    name: 'New Hampshire',
    value: 'NH',
  },
  {
    name: 'New Jersey',
    value: 'NJ',
  },
  {
    name: 'New Mexico',
    value: 'NM',
  },
  {
    name: 'New York',
    value: 'NY',
  },
  {
    name: 'North Carolina',
    value: 'NC',
  },
  {
    name: 'North Dakota',
    value: 'ND',
  },
  {
    name: 'Ohio',
    value: 'OH',
  },
  {
    name: 'Oklahoma',
    value: 'Ok',
  },
  {
    name: 'Oregon',
    value: 'OR',
  },
  {
    name: 'Pennsylvania',
    value: 'PA',
  },
  {
    name: 'Rhode Island',
    value: 'RI',
  },
  {
    name: 'South Carolina',
    value: 'SC',
  },
  {
    name: 'South Dakota',
    value: 'SD',
  },
  {
    name: 'Tennessee',
    value: 'TN',
  },
  {
    name: 'Texas',
    value: 'TX',
  },
  {
    name: 'Utah',
    value: 'UT',
  },
  {
    name: 'Vermont',
    value: 'VT',
  },
  {
    name: 'Virginia',
    value: 'VA',
  },
  {
    name: 'Washington',
    value: 'WA',
  },
  {
    name: 'West Virginia',
    value: 'WV',
  },
  {
    name: 'Wisconsin',
    value: 'WI',
  },
  {
    name: 'Wyoming',
    value: 'WY',
  },
]

// Validator functions
function alpha(value) {
  return /^[A-Z]*$/i.test(value)
}

function formName(value) {
  return /^[a-zA-Z\-' ]*$/i.test(value)
}

function email(value) {
  return emailValidator.validate(value)
}

function is(value, other) {
  return value === other
}

function isNot(value, other) {
  return value !== other
}

function max(value, length) {
  return value.length <= length
}

function min(value, length) {
  return value.length >= length
}

function numeric(value) {
  return /^[0-9]+$/.test(value)
}

function alphaNumeric(value) {
  return /^[a-z0-9]+$/i.test(value)
}

function phone(value, optional) {
  // if optional, return true if value is empty
  if (optional) {
    if (value && value.length === 0) return true
  }
  return value.replace(/\D+/g, '').length === 10
}

function regex(value, suppliedRegex) {
  return suppliedRegex.test(value)
}

function required(value) {
  if (value === undefined || value === null) return false
  return !!String(value).trim().length
}

function state(value) {
  let valid = false
  const state = value || '' // make sure state is a string
  if (state.length === 2) {
    const matchedAbb = states.filter(
      (a) => a.value.toLowerCase() === state.toLowerCase()
    )
    if (matchedAbb[0]) valid = true
  } else if (state.length >= 4) {
    const matchedState = states.filter(
      (a) => a.name.toLowerCase() === state.toLowerCase()
    )
    if (matchedState[0]) valid = true
  }
  return valid
}

function notInside(value, set) {
  if (set.indexOf(value) === -1) return true
  return false
}

function minIfOne(value, length) {
  if (value.length > 0) {
    return value.length >= length
  }
  return true
}

function isDate(value) {
  return value instanceof Date
}

export function validateField(value, rules, comparitor) {
  for (let i = 0; i < rules.length; i++) {
    if (!getValidityForRule(rules[i], value, comparitor)) {
      return false
    }
  }
  return true
}

export function getValidityForRule(rule, value, comparitor) {
  let valid = false
  if (rule === 'alpha') {
    valid = alpha(value)
  } else if (rule === 'formName') {
    valid = formName(value)
  } else if (rule === 'email') {
    valid = email(value)
  } else if (rule === 'is') {
    valid = is(value, comparitor)
  } else if (rule === 'isNot') {
    valid = isNot(value, comparitor)
  } else if (rule === 'max') {
    valid = max(value, comparitor)
  } else if (rule === 'min') {
    valid = min(value, comparitor)
  } else if (rule === 'numeric') {
    valid = numeric(value)
  } else if (rule === 'alphaNumeric') {
    valid = alphaNumeric(value)
  } else if (rule === 'phone') {
    valid = phone(value, false)
  } else if (rule === 'optionalPhone') {
    valid = phone(value, true)
  } else if (rule === 'regex') {
    valid = regex(value, comparitor)
  } else if (rule === 'required') {
    valid = required(value)
  } else if (rule === 'state') {
    valid = state(value)
  } else if (rule === 'notIn') {
    valid = notInside(value, comparitor)
  } else if (rule === 'minIfOne') {
    valid = minIfOne(value, comparitor)
  } else if (rule === 'isDate') {
    valid = isDate(value)
  } else if (rule === 'creditCard') {
    let validCard = false
    let validType = false
    // Validate credit card number, type, and cvv
    const validation = CardValidator.number(value)
    if (validation && validation.card) {
      validCard = validation.isValid
      // Card type
      const cType = validation.card.niceType
      validType =
        cType === 'American Express' ||
        cType === 'Mastercard' ||
        cType === 'Visa'
    }
    valid = validCard && validType
  } else if (rule === 'creditCardExpiry') {
    const dateValidation = CardValidator.expirationDate(value)
    valid = dateValidation && dateValidation.isValid
  } else if (rule === 'creditCardCVV') {
    let codeLength = 3
    // If card is Amex, set code length to 4
    const cardValidator = CardValidator.number(comparitor)
    if (
      cardValidator &&
      cardValidator.card &&
      cardValidator.card.niceType === 'American Express'
    ) {
      codeLength = 4
    }
    valid = CardValidator.cvv(value, codeLength)
  }
  return valid
}

export const userJsonToForm = {
  firstName: 'first_name',
  lastName: 'last_name',
  studentId: 'student_id',
  password: 'password',
  confirmPassword: 'password',
  emailAddress: 'email',
  confirmEmailAddress: 'email',
  phoneNumber: 'phone',
  address: 'address',
  city: 'city',
  state: 'state',
  zipCode: 'zip',
}

export function selectedStateListener(newValue) {
  let valid = false
  let error = 'A state is required'
  if (newValue) {
    if (newValue.length === 2) {
      /* eslint-disable-next-line */
      const matchedAbb = states.filter((a) => {
        return a.value.toLowerCase() === newValue.toLowerCase()
      })
      if (matchedAbb[0]) {
        valid = true
        error = ''
      } else {
        error = 'Please enter a valid state'
      }
    } else if (newValue.length >= 4) {
      /* eslint-disable-next-line */
      const matchedState = states.filter((a) => {
        return a.name.toLowerCase() === newValue.toLowerCase()
      })
      if (matchedState[0]) {
        valid = true
        error = ''
      } else {
        error = 'Please enter a valid state'
      }
    } else {
      error = 'Please enter a valid state'
    }
  }
  return {
    valid,
    error,
  }
}

export const customerAllergenFilters = [
  'Egg',
  'Fish',
  'Gluten',
  'Milk',
  'Peanuts',
  'Shellfish - Crustacean',
  'Shellfish - Mollusk',
  'Soy',
  'Tree Nuts',
  'Wheat',
  'Other',
]
